module.exports = {"id":"221467","name":"Lee Chang Min","rating":"71","photo":"./data/images/photos/4/221467.png","club":{"name":"Jeju United","logo":"./data/images/clubs/JejuUnited.png"},"positions":["MOC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeeChangMin0.json
// module id = 2462
// module chunks = 0